import React, { useState, useEffect, useRef } from 'react';
import Head from 'next/head'
import { useRouter } from 'next/router';
import Layout from '../../../components/layout'
import PaginatedList from '../../../components/VariantPaginatedList';
import { Heading, Text, Divider, InputGroup, InputLeftElement, Input, Center, Flex, Box, VStack, useColorModeValue} from "@chakra-ui/react"
import { FiSearch } from "react-icons/fi";
import useSWR, { SWRConfig } from "swr";
import PhenotypeVariantsFilters from '../../../components/PhenotypeVariantsFilters';
import Container from '../../../components/Container';
import prisma from '../../../lib/prisma'

const fetcher = (url, token) =>
  fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json', token }),
    credentials: 'same-origin',
  }).then((res) => res.json())

function VariantsData() {
  const router = useRouter();
  const ref = useRef()
  
  const { data, error, isValidating } = useSWR(`/api/phenotypeVariants?phenotype=${router.query.slug}&page=${router.query.page}${router.query.search ? `&search=${router.query.search}` : ''}${router.query.significance ? `&significance=${router.query.significance}` : ''}`, fetcher, {dedupingInterval: 15000, initialData: ref.current ? ref.current : undefined, revalidateOnFocus: false })

    if (data) {
      ref.current = data;
    }

  return (
    <PaginatedList router={router} data={data} error={error} isValidating={isValidating} />
  );
}

export default function PhenotypeVariants({fallback, errorCode, results}) {
  const [pageIndex, setPageIndex] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

useEffect(() => {
  if (router.query.search) {
    setSearchQuery(router.query.search)
  }
  else {
    setSearchQuery('')
  }
}, [router])

  const onSubmit = evt => {
    evt.preventDefault();
    if (searchQuery != '') {
      router.push({
        pathname: `/phenotypes/${router.query.slug}/variants`,
        query: { search: encodeURI(searchQuery) },
    });
    }
    else {
      router.push({
        pathname: `/phenotypes/${router.query.slug}/variants`,
    });
    }
    
  };
  
  const bg = useColorModeValue("white", "darkGray.900")
  const inputBg = useColorModeValue("gray.100", "neutral.1000")
  const inputText = useColorModeValue("black", "white")
  const borderColor = useColorModeValue("gray.200", "neutral.900")
  const inputPlaceholderColor = useColorModeValue("darkGray.800", "darkGray.500")
  
  const onChange = evt => setSearchQuery(evt.target.value);
  
  return (
      <>
      <Layout>
      <Head>
        <title>{results.phenotype.name} Variants</title>
      </Head>
      <Container>
      <Flex px={0} py={4} mx="auto">
        <VStack
        w={'full'}
        justify={'center'}
        >
        <Center>
      <Heading as="h1" fontSize="4xl">{results.phenotype.name} Variants</Heading>
      </Center>
      <Center>
      {/* <Text as="h2" fontSize="2xl" mt={0} align="center">Discover variants in human genome</Text> */}
      </Center>
      <Center>
  
        </Center>
            </VStack>
            </Flex>
            <Divider orientation="horizontal" mt={4} mb={2} borderColor={borderColor}/>
    
    <Box maxW={["100%","100%","100%","100%"]} mb={100}>
      <Flex
        direction={['column-reverse', 'column-reverse', 'row', 'row']}
        w="full"
        justify="space-between"
        justifyContent="center"
        maxW={["100%", "100%", "100%", "100%", "85%"]}
        m="0 auto"
      >
        <Box p={4} w={["100%","100%","60%","55%"]}>
        <SWRConfig value={{ fallback }}>
          <VariantsData />
        </SWRConfig>
        </Box>
        {/* <Spacer /> */}
        <Box p={4} w={["100%","100%","40%","30%"]}>
                <Box mb={5}>
                {/* <Heading as="h5" fontSize={14} size="s" mb="2" fontWeight="normal">Search a Variant</Heading> */}
          <form onSubmit={onSubmit}>
                <InputGroup>
          <InputLeftElement
            pt={0}
            pl={0}
            fontSize={"18px"}
            pointerEvents="none"
          >
            <FiSearch />
            </InputLeftElement>
          <Input 
            pl={10} 
            color={inputText} 
            type="tel" 
            size="md" 
            placeholder="search a variant (e.g. rs665)" 
            _placeholder={{ color: inputPlaceholderColor }}
            // value={searchQuery || router.query.search}
            value={searchQuery}
            onChange={onChange} 
            borderRadius={8} 
            borderColor={"gray.500"} 
            border="0px" 
            bgColor={inputBg}/>
        </InputGroup>
        </form>
        {/* <Divider orientation="horizontal" mt={5} borderColor={borderColor}/> */}
        </Box>
        <Text fontSize={'2xl'} fontWeight="medium" mb={3}>Filters</Text>
          <PhenotypeVariantsFilters instanceId={"data"}/>
        </Box>
      </Flex>
    </Box>
    {/* {pageIndex !== props.genes.total_pages ? <div style={{ display: 'none' }}><PaginatedList pageIndex={pageIndex + 1} props={props}/></div> : null} */}
  </Container>
</Layout>
    </>
      )
  }

export async function getServerSideProps(context) {
  var queryArgs ={}
  queryArgs = {
      slug: context.params.slug
  }
  const [phenotype] = await prisma.$transaction([
      prisma.phenotypes.findUnique({
        where: queryArgs,
        select: {
          name: true,
          slug: true
        }
        }),
    ])

  const data = JSON.stringify(phenotype, (key, value) => (typeof value === 'bigint' ? value.toString() : value))
  let results  = {phenotype: JSON.parse(data)}

  return { props: { results } }
  }